export default __webpack_public_path__ + "static/media/black0.71cc08cb.gif";